(() => {
  if (window.customElements.get('product-trustpilot-slider')) return;

  class ProductTrustpilotSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-product-trustpilot-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-product-trustpilot-dot]'));
      this.previousButton = this.querySelector('[data-product-trustpilot-prev]');
      this.nextButton = this.querySelector('[data-product-trustpilot-next]');
      this.currentIndex = 0;
      this.swipeStart = null;
      this.addEventListener('click', this.onClick);
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerCancel);
      this.showSlide(0);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.removeEventListener('pointerup', this.onPointerUp);
      this.removeEventListener('pointercancel', this.onPointerCancel);
    }

    onClick = (event) => {
      if (event.target.closest('[data-product-trustpilot-prev]')) {
        this.showSlide(this.currentIndex - 1);
        return;
      }

      if (event.target.closest('[data-product-trustpilot-next]')) {
        this.showSlide(this.currentIndex + 1);
        return;
      }

      const dot = event.target.closest('[data-product-trustpilot-dot]');
      if (!dot) return;
      this.showSlide(Number(dot.dataset.productTrustpilotDot), { focusDot: true });
    };

    onPointerDown = (event) => {
      if (!event.isPrimary || event.pointerType === 'mouse') return;
      if (event.target.closest('.product-trustpilot-review__controls')) return;

      this.swipeStart = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
      };
    };

    onPointerUp = (event) => {
      if (!this.swipeStart || event.pointerId !== this.swipeStart.pointerId) return;

      const distanceX = event.clientX - this.swipeStart.x;
      const distanceY = event.clientY - this.swipeStart.y;
      this.swipeStart = null;

      if (Math.abs(distanceX) < 40 || Math.abs(distanceX) <= Math.abs(distanceY)) return;

      if (distanceX < 0) {
        this.showSlide(this.currentIndex + 1);
      } else {
        this.showSlide(this.currentIndex - 1);
      }
    };

    onPointerCancel = () => {
      this.swipeStart = null;
    };

    showSlide(index, { focusDot = false } = {}) {
      if (!this.slides.length || !Number.isInteger(index)) return;
      const safeIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      this.currentIndex = safeIndex;

      this.slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === safeIndex;
        slide.hidden = !selected;
      });

      this.dots.forEach((dot) => {
        const selected = Number(dot.dataset.productTrustpilotDot) === safeIndex;
        if (selected) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (this.previousButton) {
        this.previousButton.disabled = safeIndex === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = safeIndex === this.slides.length - 1;
      }

      if (focusDot) {
        this.dots
          .find((dot) => Number(dot.dataset.productTrustpilotDot) === safeIndex)
          ?.focus();
      }
    }
  }

  window.customElements.define('product-trustpilot-slider', ProductTrustpilotSlider);
})();
